















import { Vue, Component, Inject } from "vue-property-decorator";
import throttle from "lodash/throttle";

@Component({
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const inst = (vm as any);
      if (inst.activeIndex !== to.name) {
        inst.activeIndex = to.name;
      }
    });
  }
})
export default class MonitorLayout extends Vue {
  @Inject()
  getTitle!: Function;

  activeIndex = "WarningIndex";
  isFade = false;
  fixedHeader = false;

  created() {
    this.showHeaderFixedByScroll = throttle(this.showHeaderFixedByScroll.bind(this), 300);
  }

  mounted() {
    window.addEventListener("scroll", this.showHeaderFixedByScroll);
    document.title = "区域专利监控系统-宿迁国家高新区知识产权综合公共服务平台";
  }

  beforeDestroy() {
    window.removeEventListener("scroll", this.showHeaderFixedByScroll);
  }

  showHeaderFixedByScroll() {
    const main = (this.$refs.warningMain as Vue).$el as Element;
    const rect = main.getBoundingClientRect();
    this.fixedHeader = rect.top < 0;
  }

  handleSelect(key: any) {
    this.activeIndex = key;
  }

  onBeforeEnter() {
    // eslint-disable-next-line no-unused-expressions
    document.querySelector("html")?.scrollTo(0, 0);
    this.isFade = true;
  }

  onAfterEnter() {
    this.isFade = false;
  }
};
